import React from 'react';
import './Footer.css';

const Footer = ({ onNavigate }) => {
  const handleLinkClick = (page) => {
    if (onNavigate) onNavigate(page);
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section footer-about">
            <div className="footer-logo">
              <span className="logo-text">TKMB</span>
            </div>
            <p className="footer-description">
              Türkiye Kalite Mühendisleri Birliği – Kalite mühendisliği alanında ulusal temsil platformu. 
              Mesleki standartlar, sicil ve yetkinlik sistemi, sanayi iş birlikleri.
            </p>
            <div className="footer-social">
              <a href="mailto:info@tkmb.org" className="social-link email" aria-label="E-posta">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" fill="currentColor"/>
                </svg>
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Hızlı Linkler</h3>
            <ul className="footer-links">
              <li><a href="#anasayfa" onClick={(e) => { e.preventDefault(); handleLinkClick('home'); }}>Ana Sayfa</a></li>
              <li><a href="#hakkimizda" onClick={(e) => { e.preventDefault(); handleLinkClick('about'); }}>Hakkımızda</a></li>
              <li><a href="#uyelik" onClick={(e) => { e.preventDefault(); handleLinkClick('membership'); }}>Üyelik</a></li>
              <li><a href="#standartlar" onClick={(e) => { e.preventDefault(); handleLinkClick('standards'); }}>Mesleki Standartlar</a></li>
              <li><a href="#meslek-standardi" onClick={(e) => { e.preventDefault(); handleLinkClick('standards'); }}>Kalite Mühendisi Meslek Standardı</a></li>
              <li><a href="#sanayi" onClick={(e) => { e.preventDefault(); handleLinkClick('industry'); }}>Sanayi İş Birlikleri</a></li>
              <li><a href="#tuzuk" onClick={(e) => { e.preventDefault(); handleLinkClick('bylaws'); }}>Tüzük</a></li>
              <li><a href="#iletisim" onClick={(e) => { e.preventDefault(); handleLinkClick('contact'); }}>İletişim</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">İletişim</h3>
            <ul className="footer-contact">
              <li>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" fill="currentColor"/>
                </svg>
                <a href="tel:+905346659292">0534 665 92 92</a>
              </li>
              <li>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
                <a href="https://wa.me/905346659292" target="_blank" rel="noopener noreferrer">WhatsApp: 0534 665 92 92</a>
              </li>
              <li>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="currentColor"/>
                </svg>
                <a href="https://www.tkmb.org" target="_blank" rel="noopener noreferrer">www.tkmb.org</a>
              </li>
              <li>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" fill="currentColor"/>
                </svg>
                <a href="mailto:info@tkmb.org">info@tkmb.org</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} TKMB – Türkiye Kalite Mühendisleri Birliği. Tüm hakları saklıdır.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
